export const COUNTRY = 'COUNTRY'
export const TOKEN = 'TOKEN'
export const LANGUAGE = 'LANGUAGE'
export const TIMESTAMP = 'TIMESTAMP'
